module.exports = __webpack_public_path__ + "static/media/temp_8.5a619127.jpg";